import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/softs/audioconverter/iconBannerComment.png")